module.exports = __webpack_public_path__ + "img/app7.036e3974.jpg";